import React, { useState } from 'react';
import { connect } from 'react-redux';
import ACTIONS from '../../store/action';
import { Actions as LEGAL_ACTIONS } from '../../store/actions/legalActions';
import {
  selectOrgOutstanding,
  selectCatalogueItems,
  selectIsUpdatedDoc,
  selectGraceDaysRemaining,
} from '../../store/selectors/legalSelectors';
import AgreementsModal from './AgreementsModal';
import LegalSignatoryModal from './LegalSignatoryModal';

const OrgAgreementsModal = ({
  branding,
  showFooterAgreements,
  isFooterAgreementOpen,
  legalAgreement,
  wlSettings,
  outstandingDocs,
  catalogueItems,
  markdownCache,
  loading,
  fetchLegalMarkdown,
  acceptLegalDocuments,
  updatedDocInfo,
  dismissable,
  onDismiss,
}) => {
  const [showSignatoryModal, setShowSignatoryModal] = useState(false);
  const [signatoryDocKinds, setSignatoryDocKinds] = useState([]);

  const handleInviteSignatory = (docKinds) => {
    setSignatoryDocKinds(docKinds || []);
    setShowSignatoryModal(true);
  };

  return (
    <>
      <AgreementsModal
        scope='org'
        outstandingDocs={outstandingDocs}
        catalogueItems={catalogueItems}
        markdownCache={markdownCache}
        loading={loading}
        updatedDocInfo={updatedDocInfo}
        wlSettings={wlSettings}
        branding={branding}
        dismissable={dismissable}
        onDismiss={onDismiss}
        fetchLegalMarkdown={fetchLegalMarkdown}
        acceptLegalDocuments={acceptLegalDocuments}
        onInviteSignatory={handleInviteSignatory}
        isFooterAgreementOpen={isFooterAgreementOpen}
        legalAgreement={legalAgreement}
        onCloseFooterAgreement={() => showFooterAgreements(false, null)}
      />
      <LegalSignatoryModal
        open={showSignatoryModal}
        onClose={() => setShowSignatoryModal(false)}
        documentKinds={signatoryDocKinds}
      />
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  showFooterAgreements: (status, agreement) => dispatch(ACTIONS.showFooterLegalAgreements(status, agreement)),
  fetchLegalMarkdown: (kind, version) => dispatch(LEGAL_ACTIONS.fetchLegalMarkdown(kind, version)),
  acceptLegalDocuments: (documents) => dispatch(LEGAL_ACTIONS.acceptLegalDocuments(documents)),
});

const mapStateToProps = (state) => {
  const isFooterAgreementOpen = state.footerAgreements?.status;
  const legalAgreement = state.footerAgreements?.agreement;
  const outstandingDocs = selectOrgOutstanding(state);
  const catItems = selectCatalogueItems(state);

  const updatedDocInfo = outstandingDocs
    .filter((doc) => selectIsUpdatedDoc(state, doc.documentKind))
    .map((doc) => {
      const item = catItems.find((i) => i.documentKind === doc.documentKind);
      return {
        documentKind: doc.documentKind,
        title: item?.title || doc.documentKind,
        graceDays: selectGraceDaysRemaining(state, doc.documentKind),
      };
    });

  return {
    wlSettings: state.whiteLabelAdmin,
    branding: state.branding,
    isFooterAgreementOpen,
    legalAgreement,
    outstandingDocs,
    catalogueItems: catItems,
    markdownCache: state.legal?.markdownCache || {},
    loading: state.legal?.loading || {},
    updatedDocInfo,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgAgreementsModal);
